





































import {Component, Model, Prop, Vue} from 'vue-property-decorator';
import Loading from '@c/controls/Loading.vue';

@Component({components: {Loading}})
export default class SimpleDialog extends Vue {
  // Показатель загрузки
  @Prop({required: false, default: false})
  loading!: boolean;

  @Prop({required: false, default: true})
  persistent!: boolean;

  // Показатель наличия ошибки
  @Prop({required: false, default: false})
  error!: boolean;

  // Заголовок
  @Prop({required: false, default: ''})
  title!: string;

  // Текст кнопки действия
  @Prop({required: false, default: ''})
  actionText!: string;

  // Статус валидации
  @Prop({required: false, default: true})
  valid!: boolean;

  @Prop({required: false})
  width!: string;

  @Prop({required: false, default: '700px'})
  maxWidth!: string;

  // Модель диалога
  @Model('simpleDialogChange') _dialog!: any;
  get dialog() {
    return this._dialog;
  }
  set dialog(newValue: any) {
    if (!newValue) this.close();

    this.$emit('simpleDialogChange', newValue);
  }

  // Обработчик выбора действия
  onSelect(e: any) {
    this.$emit('select', e);
  }

  onCancel(e: any) {
    this.$emit('cancel', e);
  }

  // Действия при закрытии диалогового окна
  close() {
    this.error = false;
    this.loading = false;
  }
}
